import './social-media.css';

const SocialMedia = () => {
    return (
        <div className="social-container">
            <a href="https://www.facebook.com/zorgnetwerktrento" target="_blank" rel="noreferrer" class="btn-social btn-facebook">
                <i className="fa fa-facebook-square bigger"></i>
            </a>
            <a href="https://www.instagram.com/zorgnetwerktrento/" target="_blank" rel="noreferrer" class="btn-social btn-instagram">
                <i className="fa fa-instagram bigger"></i>
            </a>
            <a href="https://www.linkedin.com/company/zorgnetwerk-trento" target="_blank" rel="noreferrer" class="btn-social btn-linkedin">
                <i className="fa fa-linkedin bigger"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCNDPYY0wsXAOWON0fQRrIGw" target="_blank" rel="noreferrer" class="btn-social btn-youtube">
                <i className="fa fa-youtube bigger"></i>
            </a>
            <a href="https://vimeo.com/user123303654" target="_blank" rel="noreferrer" class="btn-social btn-vimeo">
                <i className="fa fa-vimeo bigger"></i>
            </a>
        </div>
    );
};

export default SocialMedia;
